(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", a = 0; a < arguments.length; a++) {
        var u = arguments[a];
        u && (i = o(i, r(u)))
      }
      return i
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number") return i;
      
      if (typeof i != "object") return"";
      
      if (Array.isArray(i)) return n.apply(null, i);
      
      if (i.toString !== Object.prototype.toString && ! i.toString.toString().includes("[native code]")) return i.toString();
      
      var a = "";
      for (var u in i) 
        t.call(i, u) && i[u] && (a = o(a, u));
      
      return a
    }
    function o(i, a) {
      return a
        ? i
          ? i + " " + a
          : i + a
        : i
    }
    e.exports
      ? (n.default = n, e.exports = n)
      : window.classNames = n
  })()
})(hm);
var cw = hm.exports;
const fw = Cf(cw);
function dw({el: e, control: t}) {
  const n = e.getAttribute("data-slide-items-id"),
    r = document.querySelectorAll(`#${n}`),
    o = parseFloat(e.getAttribute("data-diameter") ?? 1800),
    i = parseFloat(e.getAttribute("data-degrees") ?? 20),
    a = parseFloat(e.getAttribute("data-slide-width") ?? 300),
    u = parseFloat(e.getAttribute("data-drag-elastic") ?? .5),
    l = parseFloat(e.getAttribute("data-drag-transition-power") ?? .2),
    s = parseFloat(e.getAttribute("data-drag-time-constant") ?? 20),
    p = parseFloat(e.getAttribute("data-drag-bounce-stiffness") ?? 20),
    v = parseFloat(e.getAttribute("data-drag-bounce-damping") ?? 5),
    f = V.useRef([]),
    [g, m] = V.useState(!1),
    [y, w] = V.useState(0),
    [c, d] = V.useState(0),
    [h, S] = V.useState([]),
    [P, E] = V.useState([]),
    [x, C] = V.useState(),
    [M, _] = V.useState(),
    [B, G] = V.useState(0),
    K = o / h.length,
    Q = Math.round(h.length / 2);
  sw();
  const ke = I => {
      d(I.x)
    },
    $ = I => Math.round(I / K) * K;
  V.useEffect(() => {
    f.current = f.current.slice(0, h.length)
  }, [h]),
  V.useEffect(() => {}, [f]);
  const he = () => {
      let I = 1;
      const F = .1,
        te = .5;
      let X = 1,
        Z = [],
        se = 100;
      f.current.forEach((q, Pe) => {
        const J = Math.abs(q.getAttribute("data-distance")),
          vt = Math.abs(q.getAttribute("data-index")) - y <= -1;
        J >= 1 && I >= te
          ? I = I - F
          : I = 1,
        J === 2
          ? se = vt
            ? 75
            : -75
          : se = 0,
        Z.push({
          idx: Math.abs(q.getAttribute("data-index")),
          scale: I,
          opacity: X,
          distance: J,
          translateX: se
        })
      }),
      _(Z)
    },
    A = I => {
      const F = I,
        te = 0,
        X = h.length >= 1
          ? h.length - 1
          : 0;
      let Z = 3,
        se = 3,
        q = [],
        Pe = [];
      if (F + Z >= X) 
        for (let J = 0; J < Z; J++) 
          q.push(J);
        
      
      F + Z < X
        ? q = []
        : q = q.sort((J, ce) => J - ce);
      for (let J = 0; J < se; J++) {
        let ce = F - (J + 1) - 1;
        ce < te && ce <= X - 1 && (ce = X - Math.abs(ce) + 1),
        Pe.push(ce)
      }
      F - se > te
        ? Pe = []
        : Pe = Pe.sort((J, ce) => J - ce)
    };
  V.useEffect(() => {
    f.current.findIndex(I => getComputedStyle(I).getPropertyValue("transform") === "none"),
    he()
  }, [g]),
  V.useEffect(() => {
    var F, te, X, Z, se, q, Pe;
    q = document.querySelector(".fum-flavornotes-carousel-slide-item.is-active") ||
        document.querySelector(".fum-flavornotes-carousel-slide-item");

    var wrapper = document.querySelector(".mrk-product-slider-wrapper");
    const I = {
        title: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-title"),
        weight: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-weight"),
        weight_unit: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-weight-unit"),
        subheading: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-subheading"),
        text: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-text"),
        btn: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-btn"),
        review: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-review"),
        name: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-review-name"),
        location: wrapper == null ? null : wrapper.querySelector(".mrk-product-slider-review-location")
    };

    const d = (x && x.data) || {};

    if (I.title) I.title.innerHTML = d.title || "";
    if (I.weight) I.weight.innerHTML = d.weight || "";
    if (I.weight_unit) I.weight_unit.innerHTML = d.weight_unit || "";
    if (I.subheading) I.subheading.innerHTML = d.subheading || "";
    if (I.text) I.text.innerHTML = d.text || "";

    // button text + href
    if (I.btn) {
        I.btn.innerHTML = d.btn || "";
        if (I.btn.tagName === "A" && d.url) {
            I.btn.setAttribute("href", d.url);
        }
    }

    if (I.review) I.review.innerHTML = d.review || "";
    if (I.name) I.name.innerHTML = d.name || "";
    if (I.location) I.location.innerHTML = d.location || "";


  }, [x]),
  V.useEffect(() => {
    var te,
      X;
    let I = [];
    r.forEach(Z => {
      Z.querySelectorAll(".fum-flavornotes-carousel-slide-item").forEach(q => {
        const Pe = {
          data: {
            title: q.getAttribute("title"),
            weight: q.getAttribute("weight"),
            weight_unit: q.getAttribute("weight_unit"),
            subheading: q.getAttribute("subheading"),
            text: q.getAttribute("text"),
            btn: q.getAttribute("btn"),
            url: q.getAttribute("url"),
            review: q.getAttribute("review"),
            name: q.getAttribute("name"),
            location: q.getAttribute("location"),
          },
          imageUrl: q.querySelector("img").getAttribute("src")
        };
        I.push(Pe)
      })
    }),
    S(I),
    E(I);
    const F = () => {
      let Z = 0;
      return f.current.forEach(se => {
        Math.abs(se.getAttribute("data-distance")) === 0 && (Z = se.offsetWidth)
      }),
      a ?? Z
    };
    (
      te = t == null
        ? void 0
        : t.nextButton
    ) == null || te.addEventListener("click", () => {
      O || U(F())
    }),
    (
      X = t == null
        ? void 0
        : t.prevButton
    ) == null || X.addEventListener("click", () => {
      O || Y(F())
    })
  }, []);
  const z = (I, F, te) => {
    m(I),
    F >= .9 && (w(te), C(h[te]), A(te))
  };
  P.length;
  let O = !1;
  const U = (I = 110) => {
    const F = I,
      te = f.current.length - 1;
    G(X => {
      let Z;
      return f.current.forEach((se, q) => {
        const Pe = Math.abs(se.getAttribute("data-distance")),
          J = Math.abs(se.getAttribute("data-index"));
        Pe === 0 && (Z = J)
      }),
      Math.abs(Z) < Math.abs(te)
        ? X - F
        : X
    })
  };
  V.useEffect(() => {}, [B]);
  const Y = (I = 110) => {
    const F = I;
    f.current.length - 1;
    const te = (f.current.length + 1) * F;
    G(X => (
      f.current.forEach((Z, se) => {
        Math.abs(Z.getAttribute("data-distance")),
        Math.abs(Z.getAttribute("data-index"))
      }),
      X < te
        ? X + F
        : X
    ))
  };
  return at.jsx(at.Fragment, {
    children: at.jsx("div", {
      className: "root",
      children: at.jsx("div", {
        className: "container",
        children: at.jsx($a.div, {
          drag: "x",
          onUpdate: ke,
          dragElastic: u,
          dragConstraints: {
            right: K * Q,
            left: -(K * (h.length -(Q + 1)))
          },
          dragMomentum: !0,
          dragTransition: {
            power: l,
            timeConstant: s,
            bounceStiffness: p,
            bounceDamping: v,
            modifyTarget: $
          },
          style: {
            x: B,
            touchAction: "pan-y"
          },
          children: at.jsx("div", {
            className: "fum-flavornotes-carousel",
            children: P.map(
              (I, F) => {
                const te = y === F,
                  X = (F - Q) * i,
                  Z = K / i,
                  se = c / K + (F - Q),
                  J = Math.max(1 - Math.abs(se) * .25, .3);
                let ce = 0;
                y < F && (ce = ce * -1);
                const N = o;
                // console.log(o); 2000
                console.log(c, Z, X);
                return at.jsx($a.div, {
                  "data-index": F,
                  "data-distance": Math.abs(F - y),
                  ref: T => f.current[F] = T,
                  className: fw("fum-flavornotes-carousel-item", {"slide-active": te}),
                  animate: {
                    rotate: c / Z + X,
                    transformOrigin: `50% ${N}px`,
                    scale: 1
                  },
                  transition: {
                    ease: [.17, .67, .83, .67],
                    duration: .1
                  },
                  onAnimationStart: () => m(!0),
                  onAnimationComplete: () => m(!1),
                  children: at.jsx($a.div, {
                    ref: T => f.current[F] = T,
                    animate: {
                      scale: J,
                      translateX: ce
                    },
                    transition: {
                      ease: [.17, .67, .83, .67],
                      duration: .1
                    },
                    onAnimationStart: () => m(!0),
                    onAnimationComplete: () => z(!1, J, F),
                    children: at.jsx("img", {
                      src: I.imageUrl,
                      alt: ""
                    })
                  })
                }, F)
              }
            )
          })
        })
      })
    })
  })
}
const xf = document.getElementById("fum-flavornotes-carousel-root"),
  Pf = document.querySelector("#fum-flavornotes-control-root > .fum-flavornotes-control-next"),
  Ef = document.querySelector("#fum-flavornotes-control-root > .fum-flavornotes-control-prev");
Fp(xf, Pf, Ef).render(at.jsx(V.StrictMode, {
  children: at.jsx(dw, {
    el: xf,
    control: {
      nextButton: Pf,
      prevButton: Ef
    }
  })
}));